import { render, staticRenderFns } from "./WithdrawCryptoExchangeFields.vue?vue&type=template&id=524a82a7&scoped=true"
import script from "./WithdrawCryptoExchangeFields.vue?vue&type=script&lang=js"
export * from "./WithdrawCryptoExchangeFields.vue?vue&type=script&lang=js"
import style0 from "./WithdrawCryptoExchangeFields.vue?vue&type=style&index=0&id=524a82a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524a82a7",
  null
  
)

export default component.exports